"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNestedOpts = void 0;
var tslib_1 = require("tslib");
var staticData_store_1 = tslib_1.__importDefault(require("../stores/staticData.store"));
function buildNestedOpts(parents, children, key) {
    var industries = [];
    staticData_store_1.default[parents].forEach(function (i) {
        var subind = staticData_store_1.default[children].filter(function (si) { return si[key] === i.id; });
        industries.push({
            id: i.id,
            itemId: i.id,
            type: parents,
            key: parents + i.id,
            value: i.name,
            label: i.name,
            className: 'select-parent',
            children: subind.map(function (si) { return si.name; }).join('|'),
        });
        subind.forEach(function (si) {
            industries.push({
                id: si.id,
                itemId: si.id,
                type: children,
                key: children + si.id,
                value: si.name,
                label: si.name,
                className: 'select-child',
            });
        });
    });
    return industries;
}
exports.buildNestedOpts = buildNestedOpts;
